export const TrebolitCalculatorStates = {
    loading: "loading",
    login: "login",
    loggedIn: "loggedIn",
}
